import { ENTITY } from '../config';
import { AllEntityId } from '../config/allEntityId';
import { useFetchedCampaignGroup } from '../modules/common-campaign-form/components/CampaignGroupField/hooks/useFetchedCampaignGroup';
import { useReportEntityIds } from './useReportEntityIds';
import { useReportEntityType } from './useReportEntityType';
import { useSelectedCampaign } from './useSelectedCampaign';

export const useSelectedCampaignGroup = () => {
    const [selectedEntityIds] = useReportEntityIds();
    const [selectedEntityType] = useReportEntityType();
    const { campaign } = useSelectedCampaign();
    const campaignGroupId = selectedEntityType === ENTITY.CAMPAIGNS_GROUP ? selectedEntityIds : AllEntityId;
    const fetchCampaignGroupId =
        campaignGroupId === AllEntityId ? campaign?.campaignGroupInfo?.campaignGroupId ?? AllEntityId : campaignGroupId;
    const campaignGroup = useFetchedCampaignGroup(fetchCampaignGroupId);

    return { campaignGroup, campaignGroupId };
};
